import _ from 'lodash'
import { Item } from '@/interfaces/item'
import { Form } from '@/interfaces/form'
import { Component, Prop, Watch } from 'vue-property-decorator'
import SubmitButton from '@/components/SubmitButton.vue'
import { mixins } from 'vue-class-component'
import { SetDefaultsMixin } from '@/mixins/set-defaults.mixin'
import ModalFooter from '@/components/ModalFooter.vue'

@Component({
  components: {
    SubmitButton,
    ModalFooter
  }
})
export class ModalMixin<I extends Item = Item> extends mixins(SetDefaultsMixin) implements SetDefaultsMixin {
  @Prop(Boolean)
  readonly visible?: boolean

  @Prop(Object)
  readonly item?: I

  apiConfig?: ApiConfig

  processing: boolean = false

  closeAfter: Events[] = [Events.CREATE, Events.UPDATE, Events.REMOVE]

  form: Form = {
    data: null,
    defaults: {}
  }

  get title(): string {
    return this.creating ? 'Создание' : 'Редактирование'
  }

  get creating(): boolean {
    return !this.item
  }

  async save() {
    if (this.processing) return
    this.processing = true

    try {
      if (this.creating) return this.create()
      else return this.update()
    } finally {
      this.processing = false
    }
  }

  async create() {
    const { data: item } = await this.$api.post(this.apiConfig!.path, this.form.data)

    this.$emit('created', item)
    this.toggleIfNeed(Events.CREATE)
    await this.$message.success(`Сохранено`)
  }

  async update() {
    const { id } = this.item!
    const { data: item } = await this.$api.patch(`${this.apiConfig!.path}/${id}`, this.form.data)

    this.$emit('updated', item)
    this.toggleIfNeed(Events.UPDATE)
    await this.$message.success(`Сохранено`)
  }

  async remove() {
    const { id } = this.item!
    await this.$api.delete(`${this.apiConfig!.path}/${id}`)

    this.$emit('removed')
    this.toggleIfNeed(Events.REMOVE)
    await this.$message.success(`Удалено`)
  }

  toggleIfNeed(e: Events) {
    if (this.closeAfter.includes(e)) this.toggle()
  }

  toggle() {
    this.$emit('close')
  }

  resetForm() {
    const defaults = _.cloneDeep(this.form.defaults)
    this.$set(this.form, 'data', this.creating ? defaults : this.setDefaults(this.item, defaults))
  }

  @Watch('visible', { immediate: true })
  onVisibleChange(visible) {
    if (!visible) return
    this.resetForm()
  }
}

export interface ApiConfig {
  path: string
}

export enum Events {
  CREATE,
  UPDATE,
  REMOVE
}
